/* INDRI – prekių ženklų juosta: entrance on first view, exit animation on navigation. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  // A transparent header floats over the top of the page. If the bar ends up underneath it
  // (e.g. product pages, where only a thin spacer precedes it), push the bar below the header.
  function clearTransparentHeader(bar) {
    const header = document.getElementById('header-component');
    const section = bar.closest('.shopify-section');
    if (!header || !section || section.closest('#header-group')) return;
    section.style.marginTop = '';
    if (!header.hasAttribute('transparent') || header.dataset.stickyState === 'active') return;
    const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
    const barTop = section.getBoundingClientRect().top + window.scrollY;
    if (barTop < headerBottom) section.style.marginTop = `${Math.ceil(headerBottom - barTop)}px`;
  }

  function init(bar) {
    if (bar.dataset.indriBrandbarReady) return;
    bar.dataset.indriBrandbarReady = 'true';

    clearTransparentHeader(bar);
    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => clearTransparentHeader(bar), 150);
    });

    if (!reduced.matches && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      bar.classList.add('is-armed');
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          bar.classList.add('is-inview');
          io.disconnect();
        },
        { threshold: 0.25 }
      );
      io.observe(bar);
    }

    bar.addEventListener('click', (event) => {
      const link = event.target.closest('a.indri-brand');
      if (!link || reduced.matches) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.getAttribute('aria-current') === 'page') return;

      event.preventDefault();
      link.classList.add('is-chosen');
      bar.classList.add('is-leaving');
      window.setTimeout(() => {
        window.location.href = link.href;
      }, 280);
    });
  }

  // Back/forward cache restores the "leaving" state; reset it.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-indri-brandbar]').forEach((bar) => {
      bar.classList.remove('is-leaving');
      bar.querySelectorAll('.is-chosen').forEach((a) => a.classList.remove('is-chosen'));
    });
  });

  const run = () => document.querySelectorAll('[data-indri-brandbar]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
